import { render } from "./section-one.vue?vue&type=template&id=0871f69e&scoped=true"
import script from "./section-one.vue?vue&type=script&lang=js"
export * from "./section-one.vue?vue&type=script&lang=js"

import "./section-one.vue?vue&type=style&index=0&id=0871f69e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0871f69e"]])

export default __exports__